<div id="button-container">
  <button mat-flat-button color="primary" (click)="clickCopy()">
    {{ buttonText }}
  </button>
</div>
